import React, { useEffect, useState } from 'react';

/*
  Types
*/
import { TaskObj, TaskEditProps } from '../helpers/types';

const TaskEdit = ({ setState, task, handleUpdateTask }: TaskEditProps) => {
  const [taskTitle, setTaskTitle] = useState(task.taskTitle);
  const [taskDescription, setTaskDescription] = useState(task.taskDescription ? task.taskDescription : '');
  const [taskPrice, setTaskPrice] = useState(task.taskPrice ? task.taskPrice : '');

  useEffect(() => {
    const listener: any = window.addEventListener('click', (e: any) => {
      if (e.target.getAttribute('id') === 'popup') {
        setState(false);
      }
    });

    return () => {
      window.removeEventListener('click', listener);
    };
  }, []);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const updatedObj: TaskObj = {
      ...task,
      taskTitle,
      taskDescription,
      taskPrice,
    };
    handleUpdateTask(updatedObj);
    setState(false);
  };

  return (
    <>
      <section id="popup" className="centered popup">
        <form className="centered__form" onSubmit={handleSubmit}>
          <input
            className="form__input"
            value={taskTitle}
            onChange={e => setTaskTitle(e.target.value.toLowerCase())}
            type="text"
            maxLength={40}
            placeholder="Enter task name" />
          <textarea
            className="form__input textarea"
            value={taskDescription}
            onChange={e => setTaskDescription(e.target.value.toLowerCase())}
            placeholder="Enter task description" />
          <div className="form__input--price">
            <p className="price__overlay">€</p>
            <input
              onWheel={event => event.currentTarget.blur()}
              className="form__input"
              value={taskPrice}
              onChange={e => setTaskPrice(e.target.value.toLowerCase())}
              type="number"
              min={0}
              step="0.01"
              placeholder="Enter task price" />
          </div>
          <div className="taskEdit__buttons">
            <button className="taskEdit__btn" type="button" onClick={() => setState(false)}>Cancel</button>
            <button className="taskEdit__btn save" type="submit">Save</button>
          </div>
        </form>
      </section>
    </>
  );
};

export default TaskEdit;
